// src/components/Layout/Header.jsx
import React from 'react';
import { Search, RefreshCw } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

export default function Header() {
    const { user } = useAuth();

    return (
        <header className="bg-white shadow-sm border-b">
            <div className="px-6 py-4 flex items-center justify-between">
                <div className="flex items-center flex-1">
                    <div className="max-w-md w-full">
                        <div className="relative">
                            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
                            <input
                                type="text"
                                placeholder="Search emails..."
                                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            />
                        </div>
                    </div>
                </div>

                <div className="flex items-center space-x-4">
                    <button className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-full">
                        <RefreshCw className="h-5 w-5" />
                    </button>
                    <div className="flex items-center">
                        <span className="text-sm text-gray-700">{user?.email.split('@').slice(0)[0].toUpperCase()}</span>
                    </div>
                </div>
            </div>
        </header>
    );
}
